import { FC, useEffect } from 'react';
import { toggleAdaChat } from '@bizzabo/ada-chatbot';
import { Text } from '@bizzabo/design-system';

import { AppToolId, BuildInAppToolId } from '../../../types/appTools';
import { useStyles } from './AdaChatWrapper.style';

interface AdaChatWrapperProps {
    isExpanded: boolean;
    selectedApp: AppToolId;
    shouldShowCollapseAnimation: boolean;
    shouldShowExpandAnimation: boolean;
}

const AdaChatWrapper: FC<AdaChatWrapperProps> = ({
    isExpanded,
    selectedApp,
    shouldShowCollapseAnimation,
    shouldShowExpandAnimation,
}) => {
    const classes = useStyles({
        shouldShowCollapseAnimation,
        shouldShowExpandAnimation,
        isExpanded,
    })();

    useEffect(() => {
        const toggleChatIfNeeded = async () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const chatBotState = await window.adaEmbed?.getInfo();
            const isChatOpen = chatBotState?.isChatOpen;
            const isSupportChatSelected = selectedApp === BuildInAppToolId.SupportChat;

            const chatMustBeOpened = isSupportChatSelected && isExpanded && !isChatOpen;
            const anotherAppSelected = !isSupportChatSelected && isChatOpen && isExpanded;
            const chatMustBeClosed = isSupportChatSelected && isChatOpen && !isExpanded;

            if (chatMustBeOpened || anotherAppSelected || chatMustBeClosed) {
                toggleAdaChat();
            }
        };

        toggleChatIfNeeded();
    }, [isExpanded, selectedApp]);

    return (
        <Text variant="t40" className={classes.header}>
            Support
        </Text>
    );
};

export default AdaChatWrapper;
